import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../styles/theme';
import { useAuthStore } from '../../store/authStore';
import { logout } from '../../api/auth';
import Sidebar from './Sidebar';
import { toast } from 'sonner';

const PageLayout = ({ children, showSidebar = true }) => {
  const navigate = useNavigate();
  const { user, clearAuth } = useAuthStore();
 
  const handleLogout = async () => {
    try {
      await logout();
      clearAuth();
      navigate('/login');
      toast.success('Erfolgreich abgemeldet');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };
 
  return (
    <Container>
      {showSidebar && (
        <Sidebar user={user} onLogout={handleLogout} />
      )}
      <Content showSidebar={showSidebar}>
        <ContentInner>
          {children}
        </ContentInner>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

const Content = styled.main`
  flex: 1;
  overflow: auto;
  padding: ${theme.spacing.md};
  background-color: ${theme.colors.backgroundAlt};
  margin-left: ${({ showSidebar }) => (showSidebar ? '260px' : '0')};
  transition: margin-left ${theme.transitions.normal};
 
  @media (max-width: ${theme.breakpoints.lg}) {
    margin-left: 0;
    padding: ${theme.spacing.sm};
  }
`;

const ContentInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${theme.colors.surface};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.boxShadow.sm};
  padding: ${theme.spacing.lg};
  min-height: calc(100vh - 2rem);
 
  @media (max-width: ${theme.breakpoints.lg}) {
    padding: ${theme.spacing.md};
  }
 
  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.sm};
  }
`;

export default PageLayout;